import apiClient from '@/services/api';
import type { ApiResponse } from '../applications/applicationsService';

export interface PaymentDetails {
    id: string;
    enrollment_number: string;
    student_name: string;
    email: string;
    cohort_name: string;
    amount: number;
    currency: string;
    status: string;
    lor_path?: string;
}

export interface RazorpayOrderData {
    order_id: string;
    amount: number;
    currency: string;
    key_id: string;
    student: {
        name: string;
        email: string;
        contact: string;
    };
    cohort_name: string;
    is_mock: boolean;
}

const paymentsService = {
    getPaymentDetails: async (enrollmentId: string): Promise<ApiResponse<PaymentDetails>> => {
        const res = await apiClient.get<ApiResponse<PaymentDetails>>(`/payments/details/${enrollmentId}`);
        return res.data;
    },

    createOrder: async (enrollmentId: string): Promise<ApiResponse<RazorpayOrderData>> => {
        const res = await apiClient.post<ApiResponse<RazorpayOrderData>>(`/payments/create-order/${enrollmentId}`);
        return res.data;
    },

    verifyPayment: async (payload: {
        enrollmentId: string;
        orderId: string;
        paymentId: string;
        signature: string;
    }): Promise<ApiResponse<any>> => {
        const res = await apiClient.post<ApiResponse<any>>('/payments/verify', payload);
        return res.data;
    },
};

export default paymentsService;
